import(/* webpackMode: "eager" */ "/root/Coffee/app/page.tsx");
